module.exports = __webpack_public_path__ + "static/media/icono_ganancias.1688728e.svg";